import React from 'react';

/** 坐标系 / 输出格式选择（单个、批量转换共用） */
export default function SystemFormatSelectors({
  fromSystem,
  setFromSystem,
  toSystem,
  setToSystem,
  outputFormat,
  setOutputFormat,
  coordinateSystems,
  outputFormats
}) {
  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <label style={{ display: 'block', marginBottom: 5, fontWeight: 'bold' }}>坐标系转换</label>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap',
          gap: '8px'
        }}>
          <select
            value={fromSystem}
            onChange={e => setFromSystem(e.target.value)}
            style={{
              padding: '8px 6px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '14px',
              minWidth: '120px',
              maxWidth: '180px',
              flex: '0 1 auto'
            }}
          >
            {coordinateSystems.map(sys => (
              <option key={sys.code} value={sys.code}>{sys.name}</option>
            ))}
          </select>
          <span style={{
            color: '#666',
            fontWeight: 'bold',
            fontSize: '16px',
            flexShrink: 0
          }}>→</span>
          <select
            value={toSystem}
            onChange={e => setToSystem(e.target.value)}
            style={{
              padding: '8px 6px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '14px',
              minWidth: '120px',
              maxWidth: '180px',
              flex: '0 1 auto'
            }}
          >
            {coordinateSystems.map(sys => (
              <option key={sys.code} value={sys.code}>{sys.name}</option>
            ))}
          </select>
        </div>
      </div>
      <div style={{ marginBottom: 20 }}>
        <label style={{ display: 'block', marginBottom: 5, fontWeight: 'bold' }}>输出格式</label>
        <select
          value={outputFormat}
          onChange={e => setOutputFormat(e.target.value)}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
        >
          {outputFormats.map(fmt => (
            <option key={fmt.code} value={fmt.code}>{fmt.name}</option>
          ))}
        </select>
      </div>
    </>
  );
}
